var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"highchart-container"},[_c('chart',{key:_vm.state.chartUID,ref:"highchartRef",staticClass:"highchart",attrs:{"options":_vm.optionsChart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }